const assets = {
    images: {
        logo: require("./images/bucher.png"),
        mockJournalPic: require("./images/mock-journal-pic.jpg"),
        genericJournalImage: require("./images/generic-journal-image.jpg"),
        microsoftIcon: require("./images/microsoft.png"),
    }
};

export default assets;